<template>
  <div class="footer">
    <div class="buy-me-a-coffee">
      <link href="https://fonts.googleapis.com/css?family=Cookie" rel="stylesheet" />
      <a class="bmc-button" target="_blank" href="https://www.buymeacoffee.com/chHAzigTb">
        <img src="https://cdn.buymeacoffee.com/buttons/bmc-new-btn-logo.svg" alt="Buy me a coffee" />
        <span style="margin-left:5px;font-size:28px !important;">Buy me a coffee</span>
      </a>
    </div>
    <div class="socialShare">
      <span class="socialIcons">
        <a
          href="https://twitter.com/intent/tweet?url=https://usetaski.com&text=Boost your productivity with Taski! Join @usetaski and make better decision now!"
          target="_blank"
        >
          <i style="color: #38A1F3" class="fab fa-2x fa-twitter" aria-hidden="true"></i>
        </a>
      </span>

      <span class="socialIcons">
        <a href="https://www.facebook.com/sharer/sharer.php?u=usetaski.com" target="_blank">
          <i class="fab fa-2x fa-facebook-f" aria-hidden="true" target="_blank"></i>
        </a>
      </span>
      <span class="socialIcons">
        <a
          target="_blank"
          style="color: #0e76a8;"
          href="https://www.linkedin.com/shareArticle?mini=true&url=https://usetaski.com/"
          onclick="window.open(this.href, 'width=550,height=435');return false;"
        >
          <i class="fab fa-2x fa-linkedin-in" aria-hidden="true"></i>
        </a>
      </span>
    </div>
    <p>
      Made with
      <i class="fas fa-heart heartIcon"></i> by
      <a href="https://mohitkhare.me" target="blank">Mohit</a>
    </p>
  </div>
</template>

<script>
export default {};
</script>

<style scoped>
.heartIcon {
  color: red;
}

a {
  font-weight: bold;
}

.footer {
  font-size: 1em;
  padding: 0.7em;
}

.socialIcons {
  padding: 1em;
  font-size: 0.85em;
}

.socialShare {
  margin: 1em;
}

/* Buy me a coffee */

.buy-me-a-coffee {
  padding: 10px;
  margin-top: 10px;
}

.bmc-button img {
  height: 34px !important;
  width: 35px !important;
  margin-bottom: 1px !important;
  box-shadow: none !important;
  border: none !important;
  vertical-align: middle !important;
}
.bmc-button {
  padding: 7px 15px 7px 10px !important;
  line-height: 35px !important;
  height: 51px !important;
  text-decoration: none !important;
  display: inline-flex !important;
  color: #ffffff !important;
  background-color: #ff813f !important;
  border-radius: 5px !important;
  border: 1px solid transparent !important;
  padding: 7px 15px 7px 10px !important;
  font-size: 22px !important;
  letter-spacing: 0.6px !important;
  box-shadow: 0px 1px 2px rgba(190, 190, 190, 0.5) !important;
  -webkit-box-shadow: 0px 1px 2px 2px rgba(190, 190, 190, 0.5) !important;
  margin: 0 auto !important;
  font-family: "Cookie", cursive !important;
  -webkit-box-sizing: border-box !important;
  box-sizing: border-box !important;
}
.bmc-button:hover,
.bmc-button:active,
.bmc-button:focus {
  -webkit-box-shadow: 0px 1px 2px 2px rgba(190, 190, 190, 0.5) !important;
  text-decoration: none !important;
  box-shadow: 0px 1px 2px 2px rgba(190, 190, 190, 0.5) !important;
  opacity: 0.85 !important;
  color: #ffffff !important;
}
</style>